import { render, staticRenderFns } from "./DisplayGroups.vue?vue&type=template&id=5ff08b52&"
import script from "./DisplayGroups.vue?vue&type=script&lang=js&"
export * from "./DisplayGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff08b52')) {
      api.createRecord('5ff08b52', component.options)
    } else {
      api.reload('5ff08b52', component.options)
    }
    module.hot.accept("./DisplayGroups.vue?vue&type=template&id=5ff08b52&", function () {
      api.rerender('5ff08b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/outputs/DisplayGroups.vue"
export default component.exports